import { Link } from "react-router-dom";
import { Box, Button, CardMedia, Grid, Typography } from "@mui/material";

import imageUrl from "@/assets/images/resources/resources.png";
import { ROUTES } from "@/utils/navigation";
import {
  becomeDealerDesktopButtonStyles,
  becomeDealerMobileButtonStyles,
} from "./styles";

const BecomeDealer = () => {
  return (
    <Box
      bgcolor="primary.main"
      borderRadius={3}
      px={{ xs: 2, md: 4 }}
      pt={{ xs: 2, md: 4 }}
      pb={{ xs: 2, md: 0 }}
      mb={{ xs: 5, md: 8, lg: 15.75 }}
    >
      <Grid container spacing={{ xs: 0, md: 2 }}>
        <Grid item xs={12} md={6}>
          <Typography
            variant="h2"
            color="white"
            fontSize={"1.5rem !important"}
            mb={1}
          >
            Become an installer
          </Typography>
          <Typography
            variant="subtitle2"
            color="white"
            fontWeight={600}
            component="p"
            mb={{ xs: 4, md: 5.75 }}
            maxWidth={610}
          >
            Join our installer program to empower your business with innovative tracking solutions and lucrative opportunities.
          </Typography>
          <Button
            variant="soft"
            color="secondary"
            component={Link}
            sx={becomeDealerDesktopButtonStyles}
            to={`${ROUTES.becomeDealer}`}
          >
            Send request
          </Button>
        </Grid>

        <Grid item xs={12} md={6}>
          <Box
            sx={{
              width: "100%",
              mx: "auto",
              maxWidth: { md: 323 },
              height: { xs: "auto", md: "100%" },
              maxHeight: { xs: "auto", md: 252 },
              display: "flex",
              alignItems: "end",
            }}
            mb={{ xs: 4, md: 0 }}
          >
            <CardMedia
              component="img"
              image={imageUrl}
              sx={{
                width: { xs: "100%" },
                height: { xs: "auto", md: "100%" },
                objectFit: "contain",
              }}
            />
          </Box>
        </Grid>

        <Button
          variant="soft"
          color="secondary"
          component={Link}
          sx={becomeDealerMobileButtonStyles}
          to={`${ROUTES.becomeDealer}`}
        >
          Send request
        </Button>
      </Grid>
    </Box>
  );
};

export default BecomeDealer;
